import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"className":"pa-2"}},[_c(VCardTitle,{attrs:{"className":"subheading font-weight-bold info--text"}},[_c('span',[_vm._v(_vm._s(_vm.sectionName)+" di "+_vm._s(_vm.loggedUser.name))]),_c(VSpacer)],1),_c(VCardActions)],1)}
var staticRenderFns = []

export { render, staticRenderFns }